import {Fragment} from "react";
import {Dialog, DialogPanel, Transition, TransitionChild} from "@headlessui/react";
import {XMarkIcon} from "@heroicons/react/24/outline";
import {useAtom} from "jotai/index";
import {showMobileSidebarAtom} from "./Storage";
import {MagnifyingGlassIcon} from "@heroicons/react/24/solid";
import {DebounceInput} from "react-debounce-input";
import {useSearchBox} from "react-instantsearch";
import {NewspaperFilters} from "../../tags/Filters/NewspaperFilters";
import AdvertisementFilters from "../../tags/Filters/AdvertisementFilters";
import {EnslavedPersonFilters} from "../../tags/Filters/EnslavedPersonFilters";

export default function MobileSidebar() {

    const [showMobileSidebar, setShowMobileSidebar] = useAtom(showMobileSidebarAtom);

    const {query, refine: searchRefine} = useSearchBox();

    return (
        <>
            <Transition show={showMobileSidebar} as={Fragment}>
                <Dialog as="div" className="relative z-50 lg:hidden" onClose={setShowMobileSidebar}>
                    <TransitionChild
                        as={Fragment}
                        enter="transition-opacity ease-linear duration-100"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity ease-linear duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-900/80"/>
                    </TransitionChild>

                    <div className="fixed inset-0 flex">
                        <TransitionChild
                            as={Fragment}
                            enter="transition ease-in-out duration-300 transform"
                            enterFrom="-translate-x-full"
                            enterTo="translate-x-0"
                            leave="transition ease-in-out duration-300 transform"
                            leaveFrom="translate-x-0"
                            leaveTo="-translate-x-full"
                        >
                            <DialogPanel className="relative mr-16 flex w-full max-w-xs flex-1">
                                <TransitionChild
                                    as={Fragment}
                                    enter="ease-in-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in-out duration-300"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                                        <button type="button" className="-m-2.5 p-2.5"
                                                onClick={() => setShowMobileSidebar(false)}>
                                            <span className="sr-only">Close sidebar</span>
                                            <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true"/>
                                        </button>
                                    </div>
                                </TransitionChild>
                                {/* Sidebar component, swap this element with another sidebar if you like */}
                                <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-2">
                                    <h1 className="text-xl mt-6">Search Filters</h1>

                                    <div className="w-fill">
                                        <label htmlFor="search" className="sr-only">
                                            Search
                                        </label>
                                        <div className="relative">
                                            <div
                                                className="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
                                                <MagnifyingGlassIcon className="h-5 w-5 text-gray-400"
                                                                     aria-hidden="true"/>
                                            </div>

                                            <DebounceInput
                                                id="search"
                                                name="search"
                                                className="block w-full bg-white border border-gray-300 rounded-md py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:outline-none focus:text-gray-900 focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                placeholder="Search the database..."
                                                type="text"
                                                value={query}
                                                autoFocus={true}
                                                minLength={2}
                                                debounceTimeout={500}
                                                onChange={(e) => searchRefine(e.target.value)}
                                            />

                                        </div>
                                    </div>

                                    <hr />

                                    <nav className="flex flex-1 flex-col">
                                        <NewspaperFilters />
                                        <hr/>
                                        <AdvertisementFilters />
                                        <hr/>
                                        <EnslavedPersonFilters />
                                    </nav>
                                </div>
                            </DialogPanel>
                        </TransitionChild>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}